<template>
  <div>
    <portfolio-filter-link :filterLayout="filterLayout"></portfolio-filter-link>
    <portfolio-list-link :listLayout="listLayout" :portfolioData="List"></portfolio-list-link>
    <pagination-link :paginationLayout="paginationLayout" :type="portfolioType"></pagination-link>
  </div>
</template>

<script>
import PortfolioFilterLink from "@/components/portfolio/PortfolioFilterLink";
import PortfolioListLink from "@/components/portfolio/PortfolioListLink";
import PaginationLink from "@/components/portfolio/PaginationLink";
import portfolioUtil from "@/components/portfolio/portfolioUtil";

export default {
  name: "PortfolioListComponent",
  mixins: [portfolioUtil],
  components: {
    PortfolioFilterLink,
    PortfolioListLink,
    PaginationLink
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    portfolioType: {default: ''}
  },
  data() {
    return{
      getFunc: '',
      listLayout: '',
      filterLayout: '',
      paginationLayout: '',

      // /*필터 classname*/
      // filterStartDate: '',
      // filterEndDate: '',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.initConfig();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initConfig(){
      let configPortfolio = this.returnPortfolioConfig(this.portfolioType);
      this.listLayout = configPortfolio.listLayout;
      this.filterLayout = configPortfolio.filterLayout;
      this.paginationLayout = configPortfolio.paginationLayout;
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>